import React from 'react';

import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import ResourceStore from '../../stores/ResourceStore';
import ServerSettingsStore from '../../stores/ServerSettingsStore';
import FAQStore from '../../stores/FAQStore';

import { StandardSingleMaterialView } from './StandardSingleMaterialView/StandardSingleMaterialView';
import { Unterrichtskonzepte } from './Unterrichtskonzepte/Unterrichtskonzepte';
import { VideoAufbereitung } from './VideoAufbereitung/VideoAufbereitung';

export const SingleMaterial = () => {
    const { portalResourceId } = useParams();

    const resourceStore = ResourceStore((state) => state);
    const serverSettingsStore = ServerSettingsStore((state) => state);
	const faqStore = FAQStore((state) => state);


    useEffect(() => {
        resourceStore.loadSearchOptions();
        resourceStore.load(portalResourceId);
        resourceStore.loadForFooterTeaser();
        serverSettingsStore.load();
		faqStore.loadVideoFAQsForFooterTeaser();

        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portalResourceId]);

    if (null == resourceStore.portalResource || null == resourceStore.footerPortalResources || null == faqStore.videoFaqItems) {
        return null;
    }
	else if ('Unterrichtskonzept' === resourceStore.portalResource.resourceType.name) {
        return (
            <Unterrichtskonzepte
                portalResource={resourceStore.portalResource}
                filterSettings={resourceStore.filterSettings}
                onToggleFilterParamSetting={
                    resourceStore.toggleFilterParamSetting
                }
                onToggleAreaCollapsedState={
                    resourceStore.toggleAreaCollapsedState
                }
                footerPortalResources={resourceStore.footerPortalResources}
                serverSettings={serverSettingsStore.serverSettings}
            />
        );
    }
	else if ('TITLE_MEDIA_TYPE_VIDEO' == resourceStore.portalResource.titleMediaType){
		return <VideoAufbereitung
                portalResource={resourceStore.portalResource}
                filterSettings={resourceStore.filterSettings}
                onToggleFilterParamSetting={
                    resourceStore.toggleFilterParamSetting
                }
                onToggleAreaCollapsedState={
                    resourceStore.toggleAreaCollapsedState
                }
                footerPortalResources={resourceStore.footerPortalResources}
                serverSettings={serverSettingsStore.serverSettings}
            />
	}
	else {
        return (
            <StandardSingleMaterialView
                portalResource={resourceStore.portalResource}
                footerPortalResources={resourceStore.footerPortalResources}
				footerVideoFAQItems={faqStore.videoFaqItems}
                serverSettings={serverSettingsStore.serverSettings}
            />
        );
    }
};
